"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.SideNavigation = void 0;

var _sideNavigation = _interopRequireDefault(require("./components/side-navigation"));

exports.SideNavigation = _sideNavigation["default"];